module.exports = __webpack_public_path__ + "static/img/sessao-expirada.27b4903e.svg";